import { Route, Routes } from "react-router-dom";

import PageContent from "components/partials/page-content/page-content";
import CampaignTemplateDetailsPage from "containers/admin/clients/client/campaign-templates-page/campaign-template-details-page";
import CampaignTemplatesPage from "containers/admin/clients/client/campaign-templates-page/campaign-templates-page";
import { CampaignWriterRulesPage } from "containers/admin/clients/client/campaign-writer-rules-page/campaign-writer-rules-page";
import { usePagePermission } from "hooks/use-page-permission";

import { Route as AppRoute } from "utilities/app-routes";

import { Permission } from "types/auth";

export const AdminRoutes = () => {
  usePagePermission(Permission.PERM_CLIENT_READ);

  return (
    <Routes>
      <Route
        path={AppRoute.campaignTemplates}
        element={
          <PageContent fixedContent>
            <CampaignTemplatesPage />
          </PageContent>
        }
      />
      <Route
        path={`${AppRoute.campaignTemplates}/:templateId`}
        element={
          <PageContent>
            <CampaignTemplateDetailsPage />
          </PageContent>
        }
      />

      <Route
        path={AppRoute.campaignWriterRules}
        element={
          <PageContent fixedContent showBreadcrumbs={false}>
            <CampaignWriterRulesPage />
          </PageContent>
        }
      />
    </Routes>
  );
};
